export const CAMPAIGN_INFLUENCER_TAG_KEYS = {
  all: ['campaignInfluencerTags'] as const,
  list: (campaignId: string) => [...CAMPAIGN_INFLUENCER_TAG_KEYS.all, 'list', campaignId] as const,
};
